<template>
  <div class="user-detail-container" v-loading="loading">
    <!-- 返回按钮 -->
    <div class="page-header detail-header">
      <div>
        <h2>用户详情</h2>
        <p>查看用户档案、权益余额、消费统计和交易记录</p>
      </div>
      <div class="header-actions">
        <el-button type="primary" :icon="Money" @click="openBenefitDialog">
          调整权益
        </el-button>
        <el-button :icon="ArrowLeft" @click="handleBack">返回列表</el-button>
      </div>
    </div>

    <div v-if="userDetail">
      <!-- 用户基本信息卡片 -->
      <el-card class="user-info-card" shadow="hover">
        <div class="user-basic-info">
          <div class="user-avatar">
            <el-avatar
              :size="100"
              :src="userDetail.userInfo.avatar"
              :icon="UserFilled"
            />
          </div>
          <div class="user-details">
            <div class="user-name">
              {{ userDetail.userInfo.username }}
              <el-tag
                v-if="userDetail.userInfo.isVip"
                type="warning"
                effect="dark"
                size="small"
                style="margin-left: 10px"
              >
                VIP
              </el-tag>
            </div>
            <div class="user-meta">
              <span class="meta-item">
                <el-icon><Phone /></el-icon>
                {{ userDetail.userInfo.phone || '未绑定' }}
              </span>
              <span class="meta-item">
                <el-icon><Message /></el-icon>
                {{ userDetail.userInfo.email || '未设置' }}
              </span>
              <span class="meta-item">
                <el-icon><Calendar /></el-icon>
                注册 {{ userDetail.stats.accountAge }} 天
              </span>
            </div>
            <div class="user-status">
              <el-tag
                :type="userDetail.userInfo.isWechatBound ? 'success' : 'info'"
                size="small"
              >
                {{
                  userDetail.userInfo.isWechatBound
                    ? '已绑定微信'
                    : '未绑定微信'
                }}：{{ userDetail.userInfo.openid }}
              </el-tag>
              <!-- <el-tag
                :type="userDetail.userInfo.isActive ? 'success' : 'danger'"
                size="small"
              >
                {{ userDetail.userInfo.isActive ? '已激活' : '未激活' }}
              </el-tag>
              <el-tag
                :type="userDetail.userInfo.isVerified ? 'success' : 'info'"
                size="small"
              >
                {{ userDetail.userInfo.isVerified ? '已认证' : '未认证' }}
              </el-tag> -->
            </div>
          </div>
        </div>
      </el-card>

      <!-- 统计数据卡片 -->
      <el-row :gutter="20" class="stats-row">
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-item">
              <div class="stat-icon coin">
                <el-icon><Money /></el-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  ¥{{ userDetail.stats.benefits.wwCoinBalance.toFixed(2) }}
                </div>
                <div class="stat-label">旺旺币余额</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-item">
              <div class="stat-icon recharge">
                <el-icon><WalletFilled /></el-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  ¥{{ userDetail.stats.totalRechargeAmount.toFixed(2) }}
                </div>
                <div class="stat-label">累计充值</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-item">
              <div class="stat-icon payment">
                <el-icon><CreditCard /></el-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  ¥{{ userDetail.stats.totalPaymentAmount.toFixed(2) }}
                </div>
                <div class="stat-label">累计支付</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="12" :md="6">
          <el-card shadow="hover" class="stat-card">
            <div class="stat-item">
              <div class="stat-icon consumption">
                <el-icon><DocumentChecked /></el-icon>
              </div>
              <div class="stat-content">
                <div class="stat-value">
                  {{ userDetail.stats.consumptionStats.totalCount }}
                </div>
                <div class="stat-label">消费次数</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 权益余额 -->
      <el-card class="section-card" shadow="hover">
        <template #header>
          <div class="card-header">
            <span class="card-title">权益余额</span>
          </div>
        </template>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="6">
            <div class="benefit-item">
              <div class="benefit-value">
                {{ userDetail.stats.benefits.resumeRemainingCount }}
              </div>
              <div class="benefit-label">剩余押题</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="benefit-item">
              <div class="benefit-value">
                {{ userDetail.stats.benefits.specialRemainingCount }}
              </div>
              <div class="benefit-label">剩余专项</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="benefit-item">
              <div class="benefit-value">
                {{ userDetail.stats.benefits.behaviorRemainingCount }}
              </div>
              <div class="benefit-label">剩余HR</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="benefit-item">
              <div class="benefit-value">
                {{ userDetail.stats.benefits.aiInterviewRemainingCount }}
              </div>
              <div class="benefit-label">AI面试次数</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="benefit-item">
              <div class="benefit-value">
                {{ userDetail.stats.benefits.aiResumeOptimizeRemainingCount }}
              </div>
              <div class="benefit-label">AI简历优化</div>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- 消费统计 -->
      <el-card class="section-card" shadow="hover">
        <template #header>
          <div class="card-header">
            <span class="card-title">消费统计</span>
          </div>
        </template>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="6">
            <div class="stat-detail-item">
              <span class="label">总次数：</span>
              <span class="value">{{
                userDetail.stats.consumptionStats.totalCount
              }}</span>
            </div>
            <div class="stat-detail-item">
              <span class="label">成功：</span>
              <span class="value success">{{
                userDetail.stats.consumptionStats.successCount
              }}</span>
            </div>
            <div class="stat-detail-item">
              <span class="label">失败：</span>
              <span class="value danger">{{
                userDetail.stats.consumptionStats.failedCount
              }}</span>
            </div>
            <div class="stat-detail-item">
              <span class="label">待处理：</span>
              <span class="value warning">{{
                userDetail.stats.consumptionStats.pendingCount
              }}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="stat-detail-item">
              <span class="label">押题面试：</span>
              <span class="value">{{
                userDetail.stats.consumptionStats.resumeQuizCount
              }}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="stat-detail-item">
              <span class="label">专项面试：</span>
              <span class="value">{{
                userDetail.stats.consumptionStats.specialInterviewCount
              }}</span>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="stat-detail-item">
              <span class="label">综合面试：</span>
              <span class="value">{{
                userDetail.stats.consumptionStats.behaviorInterviewCount
              }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- Tab 切换显示记录 -->
      <el-card class="section-card" shadow="hover">
        <el-tabs v-model="activeTab">
          <!-- 充值记录 -->
          <el-tab-pane label="充值记录" name="recharge">
            <template #label>
              <span
                >充值记录 ({{ userDetail.rechargeRecords?.total || 0 }})</span
              >
            </template>
            <el-table
              :data="userDetail.allTransactions?.list || []"
              stripe
              style="width: 100%"
              empty-text="暂无充值记录"
            >
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              />
              <el-table-column prop="_id" label="ID" min-width="120" />
              <el-table-column
                prop="planName"
                label="套餐名称"
                min-width="120"
              />
              <el-table-column
                prop="description"
                label="套餐描述"
                min-width="180"
              />
              <el-table-column
                prop="amount"
                label="金额"
                width="100"
                align="center"
              >
                <template #default="{ row }">
                  <span class="amount-text">¥{{ row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="channel"
                label="支付方式"
                width="100"
                align="center"
              >
                <template #default="{ row }">
                  <el-tag size="small">{{
                    getChannelText(row.channel)
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="paidAt"
                label="支付时间"
                width="180"
                align="center"
              />
              <el-table-column prop="orderId" label="订单号" min-width="180" />
            </el-table>
          </el-tab-pane>

          <!-- 消费记录 -->
          <el-tab-pane label="消费记录" name="consumption">
            <template #label>
              <span
                >消费记录 ({{
                  userDetail.consumptionRecords?.total || 0
                }})</span
              >
            </template>
            <el-table
              :data="userDetail.consumptionRecords?.list || []"
              stripe
              style="width: 100%"
              empty-text="暂无消费记录"
            >
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              />
              <el-table-column prop="_id" label="ID" min-width="120" />

              <el-table-column
                prop="typeName"
                label="类型"
                width="120"
                align="center"
              />
              <el-table-column
                prop="description"
                label="描述"
                min-width="180"
              />
              <el-table-column
                prop="consumedCount"
                label="消耗次数"
                width="100"
                align="center"
              />
              <el-table-column
                prop="statusName"
                label="状态"
                width="100"
                align="center"
              >
                <template #default="{ row }">
                  <el-tag :type="getStatusType(row.status)" size="small">
                    {{ row.statusName }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="startedAt"
                label="开始时间"
                width="180"
                align="center"
              >
                <template #default="{ row }">
                  {{ formatDate(row.startedAt) }}
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

          <!-- 支付记录 -->
          <el-tab-pane label="支付记录" name="payment">
            <template #label>
              <span
                >支付记录 ({{ userDetail.paymentRecords?.total || 0 }})</span
              >
            </template>
            <el-table
              :data="userDetail.paymentRecords?.list || []"
              stripe
              style="width: 100%"
              empty-text="暂无支付记录"
            >
              <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
              />
              <el-table-column prop="_id" label="ID" min-width="120" />

              <el-table-column
                prop="planName"
                label="套餐名称"
                min-width="120"
              />
              <el-table-column
                prop="description"
                label="套餐描述"
                min-width="180"
              />
              <el-table-column
                prop="amount"
                label="金额"
                width="100"
                align="center"
              >
                <template #default="{ row }">
                  <span class="amount-text">¥{{ row.amount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="channel"
                label="支付方式"
                width="100"
                align="center"
              >
                <template #default="{ row }">
                  <el-tag size="small">{{
                    getChannelText(row.channel)
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="statusName"
                label="状态"
                width="100"
                align="center"
              >
                <template #default="{ row }">
                  <el-tag :type="getPaymentStatusType(row.status)" size="small">
                    {{ row.statusName }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="createdAt"
                label="创建时间"
                width="180"
                align="center"
              >
                <template #default="{ row }">
                  {{ formatDate(row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column prop="orderId" label="订单号" min-width="180" />
            </el-table>
          </el-tab-pane>

          <!-- 人工调整记录 -->
          <el-tab-pane label="人工调整" name="benefitAdjustments">
            <template #label>
              <span
                >人工调整 ({{
                  benefitAdjustmentRecords?.total || 0
                }})</span
              >
            </template>
            <el-table
              v-loading="adjustmentLoading"
              :data="benefitAdjustmentRecords?.data || []"
              stripe
              style="width: 100%"
              empty-text="暂无人工调整记录"
            >
              <el-table-column
                prop="createdAt"
                label="调整时间"
                width="180"
                align="center"
              >
                <template #default="{ row }">
                  {{ formatDate(row.createdAt) }}
                </template>
              </el-table-column>
              <el-table-column label="旺旺币变更" width="130" align="center">
                <template #default="{ row }">
                  <span :class="getDeltaClass(row.delta?.wwCoinBalance)">
                    {{ formatSignedMoney(row.delta?.wwCoinBalance) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="AI简历优化变更"
                width="150"
                align="center"
              >
                <template #default="{ row }">
                  <span
                    :class="
                      getDeltaClass(row.delta?.aiResumeOptimizeRemainingCount)
                    "
                  >
                    {{
                      formatSignedCount(
                        row.delta?.aiResumeOptimizeRemainingCount
                      )
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="调整前/后" min-width="220">
                <template #default="{ row }">
                  <div class="benefit-snapshot">
                    <span>
                      WWB {{ formatMoneyValue(row.before?.wwCoinBalance) }} ->
                      {{ formatMoneyValue(row.after?.wwCoinBalance) }}
                    </span>
                    <span>
                      AI简历
                      {{ row.before?.aiResumeOptimizeRemainingCount || 0 }} ->
                      {{ row.after?.aiResumeOptimizeRemainingCount || 0 }}
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="reason" label="原因" min-width="180" />
              <el-table-column label="操作人" width="130" align="center">
                <template #default="{ row }">
                  {{ row.operator?.username || '-' }}
                </template>
              </el-table-column>
            </el-table>
            <div
              v-if="benefitAdjustmentRecords.total > adjustmentLimit"
              class="pagination-wrapper"
            >
              <el-pagination
                v-model:current-page="adjustmentPage"
                v-model:page-size="adjustmentLimit"
                :page-sizes="[10, 20, 50]"
                :total="benefitAdjustmentRecords.total"
                layout="total, sizes, prev, pager, next"
                @size-change="handleAdjustmentSizeChange"
                @current-change="handleAdjustmentPageChange"
              />
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>

    <el-empty v-else description="未找到用户信息" />

    <el-dialog
      v-model="benefitDialogVisible"
      title="调整权益"
      width="560px"
      destroy-on-close
    >
      <div v-if="userDetail" class="benefit-dialog">
        <el-descriptions :column="1" border class="benefit-user-summary">
          <el-descriptions-item label="用户">
            {{ userDetail.userInfo.username || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="用户ID">
            {{ userDetail.userInfo._id }}
          </el-descriptions-item>
          <el-descriptions-item label="当前权益">
            <div class="current-benefits">
              <span>WWB {{ currentBenefits.wwCoinBalance.toFixed(2) }}</span>
              <span
                >AI简历 {{ currentBenefits.aiResumeOptimizeRemainingCount }}
                次</span
              >
            </div>
          </el-descriptions-item>
        </el-descriptions>

        <el-form
          ref="benefitFormRef"
          :model="benefitForm"
          :rules="benefitRules"
          label-width="140px"
          class="benefit-form"
        >
          <el-form-item label="旺旺币余额" prop="wwCoinBalance">
            <div class="adjust-row">
              <el-input-number
                v-model="benefitForm.wwCoinBalance"
                :min="0"
                :max="1000000"
                :precision="2"
                :step="1"
                controls-position="right"
              />
              <span :class="getDeltaClass(wwCoinDelta)">
                {{ formatSignedMoney(wwCoinDelta) }}
              </span>
            </div>
          </el-form-item>

          <el-form-item
            label="AI简历优化次数"
            prop="aiResumeOptimizeRemainingCount"
          >
            <div class="adjust-row">
              <el-input-number
                v-model="benefitForm.aiResumeOptimizeRemainingCount"
                :min="0"
                :max="10000"
                :step="1"
                :precision="0"
                controls-position="right"
              />
              <span :class="getDeltaClass(aiResumeOptimizeDelta)">
                {{ formatSignedCount(aiResumeOptimizeDelta) }}
              </span>
            </div>
          </el-form-item>

          <el-form-item label="调整原因" prop="reason">
            <el-input
              v-model="benefitForm.reason"
              type="textarea"
              :rows="3"
              maxlength="200"
              show-word-limit
              placeholder="请输入调整原因"
            />
          </el-form-item>
        </el-form>
      </div>

      <template #footer>
        <el-button @click="benefitDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="benefitSubmitting"
          :disabled="!benefitChanged"
          @click="submitBenefitAdjustment"
        >
          确认调整
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  ArrowLeft,
  UserFilled,
  Phone,
  Message,
  Calendar,
  Money,
  WalletFilled,
  CreditCard,
  DocumentChecked
} from '@element-plus/icons-vue'
import {
  getUserDetail,
  updateUserBenefits,
  getUserBenefitAdjustments
} from '@/api/user'
import { dateFormat } from '@/utils/date'

const route = useRoute()
const router = useRouter()

const userDetail = ref(null)
const loading = ref(false)
const activeTab = ref('recharge')
const benefitDialogVisible = ref(false)
const benefitSubmitting = ref(false)
const adjustmentLoading = ref(false)
const benefitFormRef = ref(null)
const expectedBenefits = ref({
  wwCoinBalance: 0,
  aiResumeOptimizeRemainingCount: 0
})
const benefitAdjustmentRecords = ref({
  total: 0,
  page: 1,
  limit: 20,
  data: []
})
const adjustmentPage = ref(1)
const adjustmentLimit = ref(20)

const benefitForm = reactive({
  wwCoinBalance: 0,
  aiResumeOptimizeRemainingCount: 0,
  reason: ''
})

const benefitRules = {
  wwCoinBalance: [
    { required: true, message: '请输入旺旺币余额', trigger: 'blur' },
    {
      type: 'number',
      min: 0,
      max: 1000000,
      message: '旺旺币余额需在 0 到 1000000 之间',
      trigger: 'blur'
    }
  ],
  aiResumeOptimizeRemainingCount: [
    { required: true, message: '请输入 AI 简历优化次数', trigger: 'blur' },
    {
      type: 'integer',
      min: 0,
      max: 10000,
      message: 'AI 简历优化次数需在 0 到 10000 之间',
      trigger: 'blur'
    }
  ],
  reason: [
    { required: true, message: '请输入调整原因', trigger: 'blur' },
    {
      min: 2,
      max: 200,
      message: '调整原因需在 2 到 200 个字符之间',
      trigger: 'blur'
    }
  ]
}

const normalizeMoney = (value) => Number(Number(value || 0).toFixed(2))

const currentBenefits = computed(() => ({
  wwCoinBalance: normalizeMoney(
    userDetail.value?.stats?.benefits?.wwCoinBalance
  ),
  aiResumeOptimizeRemainingCount:
    userDetail.value?.stats?.benefits?.aiResumeOptimizeRemainingCount || 0
}))

const wwCoinDelta = computed(() =>
  normalizeMoney(
    Number(benefitForm.wwCoinBalance || 0) -
      expectedBenefits.value.wwCoinBalance
  )
)

const aiResumeOptimizeDelta = computed(
  () =>
    Number(benefitForm.aiResumeOptimizeRemainingCount || 0) -
    expectedBenefits.value.aiResumeOptimizeRemainingCount
)

const benefitChanged = computed(
  () => wwCoinDelta.value !== 0 || aiResumeOptimizeDelta.value !== 0
)

/**
 * 格式化日期
 */
const formatDate = (date) => {
  if (!date) return '-'
  const timestamp = new Date(date).getTime()
  return dateFormat(timestamp, 'YYYY-MM-DD HH:mm:ss')
}

/**
 * 获取支付渠道文本
 */
const getChannelText = (channel) => {
  const channelMap = {
    wechat: '微信',
    alipay: '支付宝',
    web: '网页'
  }
  return channelMap[channel] || channel
}

/**
 * 获取状态标签类型
 */
const getStatusType = (status) => {
  const typeMap = {
    success: 'success',
    failed: 'danger',
    pending: 'warning'
  }
  return typeMap[status] || 'info'
}

/**
 * 获取支付状态标签类型
 */
const getPaymentStatusType = (status) => {
  const typeMap = {
    success: 'success',
    pending: 'warning',
    failed: 'danger'
  }
  return typeMap[status] || 'info'
}

const formatMoneyValue = (value) => normalizeMoney(value).toFixed(2)

const formatSignedMoney = (value) => {
  const normalized = normalizeMoney(value)
  return `${normalized > 0 ? '+' : ''}${normalized.toFixed(2)}`
}

const formatSignedCount = (value) => {
  const normalized = Number(value || 0)
  return `${normalized > 0 ? '+' : ''}${normalized} 次`
}

const getDeltaClass = (value) => {
  const normalized = Number(value || 0)
  return {
    'delta-value': true,
    positive: normalized > 0,
    negative: normalized < 0
  }
}

const getBenefitAdjustmentData = async () => {
  const userId = route.query.id
  if (!userId) return

  adjustmentLoading.value = true
  try {
    const response = await getUserBenefitAdjustments(
      userId,
      adjustmentPage.value,
      adjustmentLimit.value
    )
    benefitAdjustmentRecords.value = {
      total: response?.total || 0,
      page: response?.page || adjustmentPage.value,
      limit: response?.limit || adjustmentLimit.value,
      data: response?.data || []
    }
  } catch (error) {
    console.error('获取权益调整记录失败:', error)
  } finally {
    adjustmentLoading.value = false
  }
}

/**
 * 获取用户详情
 */
const getUserDetailData = async () => {
  const userId = route.query.id
  if (!userId) {
    ElMessage.error('缺少用户ID')
    router.back()
    return
  }

  loading.value = true
  try {
    const response = await getUserDetail(userId)
    console.log('用户详情数据:', response)
    userDetail.value = response

    // 调试信息
    console.log('充值记录:', response.rechargeRecords)
    console.log('消费记录:', response.consumptionRecords)
    console.log('支付记录:', response.paymentRecords)
    await getBenefitAdjustmentData()
  } catch (error) {
    console.error('获取用户详情失败:', error)
    ElMessage.error('获取用户详情失败')
  } finally {
    loading.value = false
  }
}

const openBenefitDialog = () => {
  const benefits = currentBenefits.value
  expectedBenefits.value = { ...benefits }
  benefitForm.wwCoinBalance = benefits.wwCoinBalance
  benefitForm.aiResumeOptimizeRemainingCount =
    benefits.aiResumeOptimizeRemainingCount
  benefitForm.reason = ''
  benefitDialogVisible.value = true
}

const shouldConfirmBenefitAdjustment = () => {
  return (
    wwCoinDelta.value < 0 ||
    aiResumeOptimizeDelta.value < 0 ||
    wwCoinDelta.value >= 1000 ||
    aiResumeOptimizeDelta.value >= 20
  )
}

const submitBenefitAdjustment = async () => {
  if (!benefitFormRef.value) return

  const isValid = await benefitFormRef.value.validate().catch(() => false)
  if (!isValid) return

  if (!benefitChanged.value) {
    ElMessage.warning('权益余额未发生变化')
    return
  }

  if (shouldConfirmBenefitAdjustment()) {
    try {
      await ElMessageBox.confirm(
        `旺旺币变更 ${formatSignedMoney(
          wwCoinDelta.value
        )}，AI简历优化变更 ${formatSignedCount(
          aiResumeOptimizeDelta.value
        )}，确认提交？`,
        '确认调整权益',
        {
          confirmButtonText: '确认调整',
          cancelButtonText: '取消',
          type:
            wwCoinDelta.value < 0 || aiResumeOptimizeDelta.value < 0
              ? 'warning'
              : 'info'
        }
      )
    } catch {
      return
    }
  }

  const userId = route.query.id
  benefitSubmitting.value = true
  try {
    await updateUserBenefits(userId, {
      wwCoinBalance: normalizeMoney(benefitForm.wwCoinBalance),
      aiResumeOptimizeRemainingCount: Number(
        benefitForm.aiResumeOptimizeRemainingCount || 0
      ),
      expectedWwCoinBalance: expectedBenefits.value.wwCoinBalance,
      expectedAiResumeOptimizeRemainingCount:
        expectedBenefits.value.aiResumeOptimizeRemainingCount,
      reason: benefitForm.reason.trim(),
      requestId: `benefit-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 8)}`
    })

    ElMessage.success('权益调整成功')
    benefitDialogVisible.value = false
    await getUserDetailData()
  } catch (error) {
    const status = error.response?.status || error.response?.data?.code
    const message = error.response?.data?.message || error.message || ''
    if (status === 409 || message.includes('用户权益已变化')) {
      await getUserDetailData()
    }
  } finally {
    benefitSubmitting.value = false
  }
}

const handleAdjustmentPageChange = (val) => {
  adjustmentPage.value = val
  getBenefitAdjustmentData()
}

const handleAdjustmentSizeChange = (val) => {
  adjustmentLimit.value = val
  adjustmentPage.value = 1
  getBenefitAdjustmentData()
}

/**
 * 返回上一页
 */
const handleBack = () => {
  router.back()
}

// 初始化加载数据
onMounted(() => {
  getUserDetailData()
})
</script>

<style scoped lang="scss">
.user-detail-container {
  padding: 0;
  min-height: 100%;

  .detail-header {
    align-items: center;

    .header-actions {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-wrap: wrap;
      justify-content: flex-end;
    }
  }

  // 用户基本信息卡片
  .user-info-card {
    margin-bottom: 20px;

    .user-basic-info {
      display: flex;
      align-items: center;
      gap: 24px;

      .user-avatar {
        :deep(.el-avatar) {
          border: 1px solid var(--admin-color-border-soft);
          border-radius: 16px;
        }
      }

      .user-details {
        flex: 1;

        .user-name {
          font-size: 24px;
          font-weight: 700;
          color: var(--admin-color-text);
          margin-bottom: 12px;
          display: flex;
          align-items: center;
        }

        .user-meta {
          display: flex;
          gap: 24px;
          margin-bottom: 12px;
          color: var(--admin-color-text-regular);
          font-size: 14px;

          .meta-item {
            display: flex;
            align-items: center;
            gap: 6px;

            .el-icon {
              color: var(--admin-color-text-muted);
            }
          }
        }

        .user-status {
          display: flex;
          gap: 8px;
        }
      }
    }
  }

  // 统计卡片行
  .stats-row {
    margin-bottom: 20px;

    .stat-card {
      margin-bottom: 16px;

      .stat-item {
        display: flex;
        align-items: center;
        gap: 14px;

        .stat-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .stat-content {
          flex: 1;

          .stat-value {
            font-size: 24px;
            font-weight: 700;
            color: var(--admin-color-text);
            margin-bottom: 4px;
          }

          .stat-label {
            font-size: 14px;
            color: var(--admin-color-text-muted);
          }
        }
      }
    }
  }

  // 区域卡片
  .section-card {
    margin-bottom: 20px;

    .card-header {
      .card-title {
        font-size: 16px;
        font-weight: 700;
        color: var(--admin-color-text);
      }
    }

    // 权益项
    .benefit-item {
      text-align: center;
      padding: 18px;
      margin-bottom: 16px;
      background: #f8fafc;
      border: 1px solid var(--admin-color-border-soft);
      border-radius: 8px;

      .benefit-value {
        font-size: 32px;
        font-weight: 700;
        color: var(--admin-color-primary);
        margin-bottom: 8px;
      }

      .benefit-label {
        font-size: 14px;
        color: var(--admin-color-text-muted);
      }
    }

    // 统计详情项
    .stat-detail-item {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      .label {
        color: var(--admin-color-text-muted);
        font-size: 14px;
      }

      .value {
        font-weight: 700;
        color: var(--admin-color-text);

        &.success {
          color: var(--admin-color-success);
        }

        &.danger {
          color: var(--admin-color-danger);
        }

        &.warning {
          color: var(--admin-color-warning);
        }
      }
    }
  }

  .amount-text {
    color: var(--admin-color-danger);
    font-weight: 700;
  }

  .benefit-snapshot {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: var(--admin-color-text-regular);
    font-size: 13px;
    line-height: 18px;
  }

  .delta-value {
    color: var(--admin-color-text-muted);
    font-weight: 700;

    &.positive {
      color: var(--admin-color-success);
    }

    &.negative {
      color: var(--admin-color-danger);
    }
  }
}

.benefit-dialog {
  .benefit-user-summary {
    margin-bottom: 18px;
  }

  .current-benefits {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
    font-weight: 700;
  }

  .delta-value {
    color: var(--admin-color-text-muted);
    font-weight: 700;

    &.positive {
      color: var(--admin-color-success);
    }

    &.negative {
      color: var(--admin-color-danger);
    }
  }

  .benefit-form {
    .adjust-row {
      display: flex;
      align-items: center;
      gap: 14px;
      width: 100%;

      :deep(.el-input-number) {
        width: 220px;
      }
    }
  }
}

:deep(.el-card__header) {
  border-bottom: 1px solid var(--admin-color-border-soft);
}

:deep(.el-table) {
  margin-top: 0;

  .el-table__header {
    th {
      font-weight: 600;
    }
  }
}

:deep(.el-tabs__item) {
  font-weight: 600;
}

@media (max-width: 768px) {
  .user-detail-container {
    .user-info-card .user-basic-info {
      align-items: flex-start;
      flex-direction: column;
    }

    .user-info-card .user-basic-info .user-details .user-meta {
      flex-direction: column;
      gap: 8px;
    }
  }
}
</style>
